

import { NgModule } from '@angular/core';

import { MwcI18nPipe } from './mwc-i18n.pipe';

@NgModule({
  declarations: [MwcI18nPipe],
  exports: [MwcI18nPipe]
})
export class MwcI18nModule {}
